import React from 'react';
import { Card, Row, Col, Container } from 'react-bootstrap';

const features = [
  {
    icon: '📚',
    title: 'Tweede leven',
    text: 'Elk boek dat bij ons binnenkomt, krijgt de kans om opnieuw gelezen te worden in plaats van ongebruikt te blijven staan.',
  },
  {
    icon: '🔎',
    title: 'Eén plek, alle boeken',
    text: 'FOFOG verzamelt tweedehands boeken en brengt ze online samen, zodat u vanuit huis met één klik vindt en bestelt.',
  },
  {
    icon: '📦',
    title: 'Zelf boeken inleveren',
    text: 'Boeken die u niet meer leest? Bied ze aan via ons inkoopprogramma, ontvang een vergoeding en maak ruimte in huis.',
  },
];

const AboutScreen = () => {
  return (
    <>
      <div className='bg-primary text-white text-center py-5 mb-4 rounded-bottom'>
        <Container>
          <h1 className='fw-bold mb-3 fs-2'>Van uw boekenkast naar een nieuwe lezer</h1>
          <p className='mb-4 fs-6' style={{ opacity: 0.9 }}>
            FOFOG geeft boeken sinds 2021 een tweede, derde of zelfs vierde leven.
          </p>
          {/* <Link to='/verkoop'>
            <Button variant='light' size='lg'>
              Begin met verkopen
            </Button>
          </Link> */}
        </Container>
      </div>

      <Row className='justify-content-center'>
        <Col md={10}>
          {/* Feature grid */}
          <Row className='g-3 mb-4'>
            {features.map((feature) => (
              <Col md={4} key={feature.title}>
                <Card className='h-100 shadow-sm border-0 text-center'>
                  <Card.Body className='p-4'>
                    <div className='fs-3 mb-2'>{feature.icon}</div>
                    <Card.Title as='h3' className='fs-6 fw-semibold'>{feature.title}</Card.Title>
                    <Card.Text className='text-muted small mb-0'>{feature.text}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Story */}
          <Card className='shadow-sm border-0 mb-4'>
            <Card.Body className='p-4 p-md-5'>
              <Card.Title as='h2' className='mb-3 fs-4'>Waarom FOFOG bestaat</Card.Title>
              <p className='fs-6'>
                Een boek dat ongebruikt in een kast blijft staan, kan voor iemand anders juist veel waarde hebben.
                Bij FOFOG geloven we daarom dat boeken zo lang mogelijk gebruikt moeten worden.
              </p>
              <p className='mb-0 fs-6'>
                Door bestaande boeken opnieuw beschikbaar te maken, dragen we bij aan een duurzamere manier van
                lezen en voorkomen we dat waardevolle boeken ongebruikt blijven.
              </p>
            </Card.Body>
          </Card>

          {/* Sell books CTA */}
          <Card className='shadow-sm border-0 mb-4 bg-light'>
            <Card.Body className='p-4 p-md-5'>
              <Row className='align-items-center g-4'>
                <Col md={8}>
                  <Card.Title as='h2' className='mb-3 fs-4'>Heeft u zelf boeken die u niet meer gebruikt?</Card.Title>
                  <p className='fs-6'>
                    Of u nu student bent, een gezin heeft of gewoon boeken in de kast heeft staan die u niet meer
                    leest: iedereen kan meedoen. U maakt ruimte in huis, ontvangt een vergoeding voor uw boeken en
                    geeft ze tegelijkertijd de kans om opnieuw gelezen te worden.
                  </p>
                  <p className='mb-0 fs-6'>Zo brengen we vraag en aanbod samen en geven we boeken opnieuw waarde.</p>
                </Col>
                {/* <Col md={4} className='text-md-end text-center'>
                  <Link to='/verkoop'>
                    <Button variant='primary' size='lg'>Bekijk het inkoopprogramma</Button>
                  </Link>
                </Col> */}
              </Row>
            </Card.Body>
          </Card>

          {/* Vision callout */}
          <div className='text-center p-4 p-md-5 mb-4 rounded bg-primary bg-opacity-10'>
            <p className='text-uppercase small fw-semibold text-primary mb-2'>Onze visie</p>
            <p className='fs-5 mb-2'>
              Een betrouwbaar en gebruiksvriendelijk platform waar tweedehands boeken gemakkelijk hun weg vinden
              naar een nieuwe lezer.
            </p>
            <p className='fs-6 text-muted mb-0'>FOFOG &mdash; Geef boeken een nieuw leven.</p>
          </div>

          {/* Company details */}
          <Card className='shadow-sm border-0 mb-4'>
            <Card.Body className='p-4'>
              <Card.Title as='h2' className='mb-3 fs-6 text-muted'>Bedrijfsgegevens</Card.Title>
              <Row className='gy-2'>
                <Col sm={6}><span className='text-muted small d-block'>Handelsnaam</span><strong>FOFOG</strong></Col>
                <Col sm={6}><span className='text-muted small d-block'>Gevestigd in</span><strong>Hoogezand, Nederland</strong></Col>
                <Col sm={6}><span className='text-muted small d-block'>Actief sinds</span><strong>10 maart 2021</strong></Col>
                <Col sm={6}><span className='text-muted small d-block'>KvK-nummer</span><strong>89125363</strong></Col>
                <Col sm={6}><span className='text-muted small d-block'>BTW-nummer</span><strong>NL864886305B01</strong></Col>
              </Row>
            </Card.Body>
          </Card>

          <div className='text-center py-4'>
            <p className='mb-1 text-muted'>Vragen of opmerkingen?</p>
            <a href='mailto:fofog.boeken@gmail.com'>fofog.boeken@gmail.com</a>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default AboutScreen;
